import React from "react";
import "./style.scss";
import "../../style/typography.scss";
import { useSelector } from "react-redux";
import { State } from "../../app/store";
import EALink from "../../app/components/shared/Link/EALink";

const SellerFooterInfo: React.FC = () => {
  const configuration = useSelector((state: State) => state.config.configuration);

  return (
    <>
      {configuration.facilityName && configuration.facilityName.length > 3 && (
        <span>
          Administratorem danych osobowych <b>{configuration.facilityName} </b>
          Dane przetwarzane będą w celu realizacji zamówienia, sprzedaży biletów oraz realizacji obowiązków prawnych
          związanych z umową sprzedaży.  Więcej o tym jak przetwarzamy dane osobowe można znaleźć tutaj:
          {configuration.regulaminList[0] && (
            <EALink to={configuration.regulaminList[0].file} title="Polityka prywatności" />
          )}
        </span>
      )}
      {configuration.facilityPhone !== "" && configuration.helpDetails !== "" && (
        <span>
          <br />
          Masz pytania dotyczące oferty lub zamówienia ? Skontaktuj się:
          {configuration.helpDetails && <b> {configuration.helpDetails} </b>}
          {configuration.facilityPhone && <b> {configuration.facilityPhone} </b>}
        </span>
      )}
    </>
  );
};

export default SellerFooterInfo;
